import axios from 'axios'
import firebase from 'firebase/app'

import config from '@/config'
import { firestore } from '@/database'
import User from '@/models/User'

const currentUser = new User()

const state = {
  authFirstCheck: true,
  currentUser: null,
  engagement: null,
  integrations: null,
  isAdmin: false
}

const getters = {
  currentUid (state) {
    return state.currentUser ? state.currentUser.id : null
  },
  currentUser (state) {
    return currentUser
  },
  preferences (state) {
    return state.currentUser ? state.currentUser.preferences || {} : {}
  },
  profile (state) {
    return state.currentUser ? state.currentUser.profile || {} : {}
  },
  currentOrganization (state) {
    return state.currentUser ? state.currentUser.currentOrganization : null
  },
  currentUserPlan (state) {
    return state.currentUser ? state.currentUser.plan : null
  },

  // User role in current organization
  getUserRole: (state, getters) => (uid) => {
    let currentOrg = getters.currentOrganization
    return currentOrg && currentOrg.users ? currentOrg.users[uid] : null
  },
  getCurrentUserRole (state, getters) {
    return getters.getUserRole(getters.currentUid)
  },
  isOwner (state, getters) {
    return getters.getCurrentUserRole === 'owner'
  }
}

const mutations = {
  setCurrentUser (state, user) {
    if (user) {
      state.currentUser = {
        id: user.id,
        email: user.email,
        currentOrganization: user.currentOrganization,
        profile: { displayName: user.firstName },
        plan: user.plan
      }
      state.isAdmin = user.type === 'admin'
    } else {
      state.currentUser = null
    }
  },
  setCustomClaims (state, claims) {
    state.isAdmin = !!claims.admin
  }
}

const actions = {
  async bindCurrentUser ({ commit }, uid) {
    currentUser.on('save.success, fetch.success', () => {
      commit('atlas/syncModel', {
        path: 'user.currentUser',
        value: { ...currentUser.$ }
      }, { root: true })
    })
    await currentUser.fetch(uid)
  },
  async getAuthToken ({ state }, provider) {
    if (state.integrations && state.integrations[provider]) {
      const oauthData = state.integrations[provider]

      if (new Date().getTime() < oauthData.expiresAt) {
        // access token is still fresh
        return oauthData.accessToken
      } else {
        // access token is expired, tell the server to get a fresh one
        const userToken = await firebase.auth().currentUser.getIdToken(true)
        const response = await axios.post(
          `${config.cloudFunctions}/integrations/${provider}/refresh`, {
            userToken
          })
        return response.data.accessToken
      }
    }

    return null
  },
  setEngagement ({ state }, { what, value }) {
    const data = {}
    data[what] = value

    let ref = firestore
      .collection('engagement')
      .doc(state.currentUser.id)

    if (state.engagement) {
      ref = ref.update(data)
    } else {
      ref = ref.set(data)
    }

    return ref
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
